import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import { EnvelopeSimple, ArrowLeft } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSubmitted(true);
    } catch (err) {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050810] flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <div className="card-glass rounded-xl p-8 sm:p-10">
          <div className="text-center mb-8">
            <div className="w-20 h-20 mx-auto mb-4 bg-cyan-500/10 rounded-full flex items-center justify-center border-2 border-cyan-500/30">
              <EnvelopeSimple size={40} weight="duotone" className="text-cyan-400" />
            </div>
            <h1 className="text-2xl font-black font-['Unbounded'] text-white hero-glow mb-2">Reset Password</h1>
            <p className="text-slate-400 text-sm">We'll send you a secure reset link via email</p>
          </div>

          {submitted ? (
            <div data-testid="reset-sent-message" className="bg-cyan-500/10 border border-cyan-500/30 rounded-lg p-6 text-center">
              <p className="text-cyan-300 font-semibold mb-2">Check your inbox</p>
              <p className="text-slate-400 text-sm">If that email is registered, a password reset link is on its way. The link expires in 1 hour.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-semibold text-slate-300 mb-2">Admin Email</label>
                <input
                  data-testid="forgot-email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full bg-[#0F1528] border border-cyan-500/20 rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:outline-none focus:border-cyan-500/50"
                  placeholder="you@example.com"
                />
              </div>
              <button
                data-testid="send-reset-button"
                type="submit"
                disabled={loading}
                className="w-full bg-cyan-500 text-black font-bold px-6 py-4 rounded-md uppercase tracking-wide hover:bg-cyan-400 disabled:opacity-50"
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          )}

          <Link to="/admin/login" className="mt-6 flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-400 justify-center">
            <ArrowLeft size={16} /> Back to login
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
